module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "dark-top",
    attrs: {
      "dialog": "modal-lg",
      "header": false,
      "customClass": 'heightAuto',
      "footer": true
    }
  }, [_c('div', {
    staticClass: "p-4",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('h2', {
    staticClass: "text-center mb-3"
  }, [_vm._v(_vm._s(("Duplicate Product " + (_vm.originalProduct.name))))]), _vm._v(" "), _c('p', {
    staticClass: "mb-3"
  }, [_vm._v("\n            Please the new product name\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.isDuplicatingProduct == false && _vm.newDuplicatedProduct != null) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newDuplicatedProduct.name),
      expression: "newDuplicatedProduct.name"
    }],
    staticClass: "w-100",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newDuplicatedProduct.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newDuplicatedProduct, "name", $event.target.value)
      }
    }
  }) : _c('div', {
    staticClass: "w-100 text-center"
  }, [_c('loader')], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-all",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn cancel wider",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn ok wider",
    attrs: {
      "type": "button",
      "disabled": _vm.isInvalidValid
    },
    on: {
      "click": _vm.pressDuplicate
    }
  }, [_vm._v("Duplicate")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-b394857c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b394857c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ProductDuplicate.vue
// module id = 987
// module chunks = 0